// Employee Advance Permissions
//
// ⚠️ RECONCILE BEFORE RELEASE.
//
// The backend registers these through PermissionService::createAndGrantToOwners
// in database/migrations/2026_09_09_000007_add_employee_loan_and_hr_report_permissions.php,
// and the central key service allocates each row's id at migrate time — none of
// them can be known while writing this file. 1559-1565 are counted forward from
// the confirmed 1522 (HR_MANAGE_SETTINGS) in registration order — derived, not
// read.
//
// Read the real ids off the live rows once the migration has run:
//
//     SELECT id, name FROM permissions WHERE name LIKE 'employee_loans.%';
//
// The failure mode is deliberately closed: a wrong number means nobody holds it
// and the control is hidden, never shown to the wrong people.
export const EMPLOYEE_LOANS_INDEX = 1559;
export const EMPLOYEE_LOANS_CREATE = 1560;
export const EMPLOYEE_LOANS_UPDATE = 1561;
export const EMPLOYEE_LOANS_DELETE = 1562;
export const EMPLOYEE_LOANS_RESTORE = 1563;
// Separate from CREATE: raising an advance on paper and handing the money over
// are different trusts, and disbursing mints a payment voucher.
export const EMPLOYEE_LOANS_DISBURSE = 1564;
// Its own key because it can make an outstanding asset disappear without any
// money moving — the one action here worth granting deliberately.
export const EMPLOYEE_LOANS_SETTLE = 1565;
